import React from 'react';

const FloatingSlash = ({ className = "", color = "#9CA3AF" }) => (
  <svg className={className} width="40" height="60" viewBox="0 0 40 60" fill="none">
    <path d="M5 50 L 35 10" stroke={color} strokeWidth="0" strokeLinecap="round"/>
  </svg>
);

export default FloatingSlash;